var map = {
	"./comunebg/images/mobile/SplashScreen/splashLogo.png": "bd74",
	"./default/images/mobile/SplashScreen/splashLogo.png": "640a",
	"./emergency/images/mobile/SplashScreen/splashLogo.png": "73df",
	"./hoval/images/mobile/SplashScreen/splashLogo.png": "1024",
	"./sorint/images/mobile/SplashScreen/splashLogo.png": "e85e",
	"./vimm/images/mobile/SplashScreen/splashLogo.png": "f89a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fab2c";